import FrontGradientMaterial from '../materials/FrontGradientMaterial';
import { DEFAULT_BG_GRADIENT } from '../../../constants/colors';
import { formatGradient } from '../../../utils/gradient';

const THREE = require('three');

class GradientBackground extends THREE.Mesh {
    constructor() {
        const geometry = new THREE.PlaneBufferGeometry(100, 100);

        const params = { ...formatGradient(DEFAULT_BG_GRADIENT) };
        const material = new FrontGradientMaterial(params);

        super(geometry, material);

        this.params = params;
        this._material = material;
    }

    set viewportWidth(value) {
        this._material.viewportWidth = value;
    }

    get viewportWidth() {
        return this._material.viewportWidth;
    }

    set viewportHeight(value) {
        this._material.viewportHeight = value;
    }

    get viewportHeight() {
        return this._material.viewportHeight;
    }

    setGradient(value) {
        if (!this._material) return;
        this._material.setGradientUniforms(formatGradient(value));
    }
}

export default GradientBackground;
